import { createContext, useContext, type Component, type ParentProps } from "solid-js"

// GigaTool: one extra action beside an assistant answer's copy button, owned
// by the host app — «Отправить в Геру» (packages/app partner-actions.tsx)
// needs the desktop platform, the partner channel's state and a dialog, none
// of which this package knows. Optional: without a provider (Storybook, tests,
// the docs site) the row is unchanged, and the host's component renders
// nothing when it has nothing to offer.
export type MessageExtraActionProps = {
  sessionID: string
  messageID: string
  /** The answer's text, as the copy button would copy it. */
  text: string
  /** Absolute paths of files the answer names (resolved from inline-code names where the host can). */
  paths: string[]
}

const Context = createContext<Component<MessageExtraActionProps>>()

export function MessageActionsProvider(props: ParentProps<{ extra: Component<MessageExtraActionProps> }>) {
  return <Context.Provider value={props.extra}>{props.children}</Context.Provider>
}

export function useMessageExtraAction() {
  return useContext(Context)
}
